import React, { useState, useEffect } from 'react'
import Img from 'gatsby-image';
import './header-consulting.scss'

const HeaderConsulting = (props) => {
    const {mobile, banner} = props;

    const [pageLoad, setpageLoad] = useState(false)

    useEffect(() => {
        setpageLoad(true)
    }, [])

    return (
        <div className="f-header-consulting">
            <Img
                loading='eager'
                className="f-banner-img"
                alt={banner[mobile ? 1 : 0].description}
                fluid={banner[mobile ? 1 : 0].fluid}
                style={{'height': banner[mobile ? 1 : 0].file.details.image.height}}
            />
            <div className="f-header-consulting-title">
                <h1 className="f-main-title">Consultorios</h1>
            </div>
        </div>
    )
}

export default HeaderConsulting
